<template>
  <el-col :span="4">
    <div :class="[ checked ? 'folder-wrapper is-selected' : 'folder-wrapper' ]">
      <div class="folder-border">
        <div class="image-inner" @click="onClickImgBox">
          <el-checkbox v-model="checked" @change="onCheckChange"></el-checkbox>
          <div class="img-wrapper">
            <img style="height: 100%;max-width:100%;" :src="imgSrc"/>
          </div>
        </div>
      </div>
      <div class="folder-title" style="height: 30px;">
        <span v-show="!editing" @dblclick="onDblClickName">{{data.customimageName}}</span>
        <el-input v-show="editing" ref="nameField" placeholder="Please input" @keyup.native.enter="$refs.nameField.blur()" v-model="data.customimageName" @blur="editing = false" @change="handleChange"></el-input>
      </div>
    </div>
  </el-col>
</template>

<script>
export default {
  name: 'WImgBox',
  props: {
    data: {
      type: Object,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      checked: false,
      editing: false,
      name: this.value === undefined || this.value === null ? '' : this.value,
      imgSrc: '',
    };
  },
  watch: {
    data: {
      immediate: true,
      handler(value) {
        this.imgSrc = `data:${value.customimageMimetype} ;base64, ${value.customimageBlob}`;
        this.checked = (value.checked) ? value.checked : false;
      },
    },
    value(val) {
      this.name = val;
    },
    editing(val) {
      if (val === true) {
        this.$nextTick(() => {
          this.$refs.nameField.focus();
        });
      }
    },
  },
  methods: {
    onClickImgBox() {
      this.checked = !this.checked;
      this.onCheckChange(this.checked);
    },
    onClickImg(e) {
      e.stopPropagation();
    },
    handleChange(val) {
      // this.$emit('input', val);
      const params = {
        customimageName: val,
        customimageId: this.data.customimageId,
      };
      this.$emit('change-img-name', params);
    },
    onDblClickName() {
      this.editing = !this.editing;
    },
    onCheckChange(value) {
      this.$emit('check-change', this.data, value);
    },
    setChecked(value) {
      this.checked = value;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/ImageSettings/ImageSettingsView/components/ImgBox.vue